import { supabase } from "@/integrations/supabase/client";

/**
 * Devolve a bolha recem-transmitida ao seu `mirror_messages.id`.
 *
 * POR QUE ISTO EXISTE: o `final` do SSE do mirror-chat carrega
 * { response, proposals, session_id } — e nada mais. So as mensagens
 * carregadas do historico trazem o id da linha. Sem um id estavel, o botao de
 * denuncia da mensagem que ACABOU de chegar nao teria o que gravar, e o corte
 * pos-denuncia nao sobreviveria ao reload: as duas coisas que a politica de
 * conteudo de IA do Google exige.
 *
 * POR QUE UM SELECT E NAO UM CAMPO NOVO NO SSE: mudar o contrato do
 * mirror-chat custaria um deploy manual de edge function (regra 4.3 — MCP
 * corrompe template literal), entao o app ficaria sem denuncia ate esse deploy
 * acontecer, e a submissao ao Google e hoje. Alem disso o mirror-chat tem
 * historico de revert por scope creep (588849a). Um SELECT de uma linha,
 * client-side, entrega o mesmo id sem tocar no servidor.
 *
 * NAO HA CORRIDA: o mirror-chat INSERE a linha do assistant ANTES de emitir o
 * `final` (persist.assistant precede sendEvent no index.ts). Quando este codigo
 * roda, a linha ja existe.
 *
 * Best-effort de propósito: devolve null em qualquer falha. A bolha fica sem
 * controle de denuncia ate o proximo carregamento do historico (quando ganha o
 * id de verdade) — degrada, nao quebra, e nunca mente.
 */
export async function resolveAssistantMessageId(
  sessionId: string | null | undefined,
  finalText: string,
  guard?: { userId: string; accessToken: string; assertCurrent: () => void },
): Promise<string | null> {
  if (!sessionId || !finalText) return null;
  try {
    guard?.assertCurrent();
    let query = supabase
      .from("mirror_messages")
      .select("id, content")
      .eq("session_id", sessionId)
      .eq("role", "assistant")
      .order("created_at", { ascending: false })
      .limit(1);
    if (guard) query = query.eq("user_id", guard.userId).setHeader("Authorization", "Bearer " + guard.accessToken);
    guard?.assertCurrent(); const { data, error } = await query; guard?.assertCurrent();

    if (error) {
      console.warn("[resolveAssistantMessageId] select falhou", error);
      return null;
    }

    const row = data && data.length > 0 ? data[0] : null;
    if (!row?.id) return null;

    // Confere o conteudo antes de devolver o id: um turno concorrente (WhatsApp,
    // outro MiniMirror) pode ter inserido outra linha nesta mesma sessao entre o
    // insert e este SELECT. Carimbar o id errado faria a denuncia apontar para a
    // mensagem errada — pior que nao ter id nenhum.
    if (typeof row.content === "string" && row.content !== finalText) return null;

    return row.id as string;
  } catch (err) {
    console.warn("[resolveAssistantMessageId] lancou", err);
    return null;
  }
}
